angular.module('impactx.product').controller('ProductAttachmentCtrl', ProductAttachmentCtrl);

ProductAttachmentCtrl.$inject = ['$scope', 'dataGen', '$routeParams'];

function ProductAttachmentCtrl($scope, dataGen, $routeParams)
{
    $scope.search = function () {
        dataGen.getData($scope, {id: $routeParams.id}, '/product/view/attachments');
    };

    $scope.search();

}
